import React from "react";
import { ToastContainer } from "react-toastify";

export const Notification = () => {
  return <ToastContainer />;
};
